import type { TranslationKey } from '@/types/i18n.types';

/**
 * Sceglie la variante "Traveler" di una chiave i18n della dashboard pagamenti.
 *
 * La pagina e' la stessa per tutti i ruoli, ma il lessico no: TD, agenzia e admin
 * incassano, il viaggiatore paga. Le chiavi base restano quelle dei ruoli operativi
 * (nessun cambiamento a schermo per loro): solo il viaggiatore devia sul suffisso.
 *
 * Per ogni chiave passata qui devono esistere sia `<key>` sia `<key>Traveler` in
 * ENTRAMBI i file di traduzione, altrimenti a schermo comparirebbe la chiave grezza.
 */
export const payerKey = (key: TranslationKey, travelerView?: boolean): TranslationKey =>
    (travelerView ? `${key}Traveler` : key) as TranslationKey;
